import styled from "styled-components";
import FlagIcon from "../../../basic/flagIcon/FlagIcon";
import PhaseSixIcon from "../../../basic/phaseSixIcon/PhaseSixIcon";
import StyledButton from "../../../basic/styledButton/StyledButton";
import { ChildrenWrapper } from "../../../basic/styledButton/StyledComponents";
import DesignConstants from "../../../constants/DesignConstants";

/**
 * StyledButton splits its width between label and arrow rather than sizing to the label, so a label
 * wider than that share is squeezed instead of growing the button. Sizing the label box to its own
 * content lets the button grow past its min-width and keep the text on one line.
 */
export const MoreVocabularyButton = styled(StyledButton)`
    ${ChildrenWrapper} {
        flex-basis: auto;
    }
`;

//TODO: when we redesign the recurring task, we will have to use the design constants here.

export const TitleWrapper = styled.div`
    text-align: center;

    &.space {
        margin: 1rem 0;
    }
`;

export const Title = styled.h3``;

// Grows to fill the remaining viewport height (requires hasFullHeightContent on the header
// wrapper) so the sticky CTA footer is pushed to the bottom and never overlaps the last item.
export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${DesignConstants.SPACES.S};
    flex: 1 0 auto;
`;
export const MiddleContentWrapper = styled.div`
    background: white;
    border-radius: 0.5rem;
`;
export const BookLanguageWrapper = styled.div`
    width: 100%;
    padding: 0.5rem;
    display: flex;
    border-bottom: solid 2px ${DesignConstants.COLORS.BACKGROUND_LIGHT};
`;
export const BookLanguageNameWrapperLeft = styled.div`
    width: calc(50% - 1.5rem);
`;
export const BookLanguageNameWrapperRight = styled.div`
    flex: 1;
`;
export const StyledFlagIcon = styled(FlagIcon)`
    color: #666666;
    font-weight: 600;

    svg {
        width: 1.5rem;
        margin-right: 8px;
        border-radius: 1rem;
    }
`;
export const ExerciseVocabularyWrapper = styled.div``;
export const BookInfoAndCTA = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
`;
export const DeleteAllCTAWrapper = styled.div`
    color: #666;
    padding-top: 3px;
    cursor: pointer;

    &.disabled {
        pointer-events: none;
        opacity: 0.5;
    }
`;
export const SmallIcon = styled(PhaseSixIcon)`
    font-size: 1.5rem;
`;
export const CardsCountMobileWrapper = styled.div`
    width: 100%;
    text-align: right;
    margin-bottom: 0.5rem;
    padding-right: 0.5rem;
`;
